import { Component, OnInit, isDevMode } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { HelpersService } from '../../../services/helpers.service';
import { UserService } from '../../../services/user.service';
import { PartnerService } from '../../../services/partner.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-insurancelogin',
  templateUrl: './insurancelogin.component.html',
  styleUrls: ['./insurancelogin.component.scss'],
})
export class InsuranceloginComponent implements OnInit {
  public form: any = { username: '', password: '' };
  public loggingIn: boolean = false;
  public error: boolean = false;
  public errorMessage: string = '';
  public returnURL: string = null;

  constructor(
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public partnerService: PartnerService,
    public helpersService: HelpersService,
    public router: Router,
    public route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['returnUrl']) {
        this.returnURL = params['returnUrl'];
      }
    });
  }

  public authNewAPI(callback) {
    this.authenticationService
      .authenticateClub(this.form.username, this.form.password)
      .subscribe(
        (result) => {
          this.helpersService.saveAuthDataNew({
            token: result.token,
            username: this.form.username,
          });
          callback();
        },
        (error) => {
          this.loggingIn = false;
        },
      );
  }

  public login() {
    this.loggingIn = true;
    this.authenticationService
      .authenticate(this.form.username, this.form.password)
      .subscribe(
        (result) => {
          this.helpersService.saveAuthData(result);

          //Now we need to see what this user is? Raw, Policy Holder, Insurance Company
          this.userService.getUserDetail(this.form.username).subscribe(
            (user) => {
              const profile = user;
              console.log(profile);
              this.helpersService.saveProfileData(profile);
              //Get the roles
              this.userService.getUserRolesInsurance(profile.ID).subscribe(
                (permissions) => {
                  if (permissions.roleID === 0) {
                    this.loggingIn = false;
                    this.error = true;
                    this.errorMessage =
                      'You do not have access to the insurance portal.';
                    this.router.navigateByUrl('/insurance');
                    return;
                  }
                  this.authenticationService
                    .authenticateClub(this.form.username, this.form.password)
                    .subscribe(
                      (result) => {
                        this.helpersService.saveAuthDataNew({
                          token: result.token,
                          username: this.form.username,
                          userID: profile.ID,
                        });
                      },
                      (error) => {
                        this.loggingIn = false;
                        this.error = true;
                        this.errorMessage =
                          error && error.error_description
                            ? error.error_description
                            : 'The user name or password is incorrect.';
                      },
                    );

                  console.log(this.helpersService.getNewApiHeaders());
                  const profile = permissions;
                  console.log(permissions);
                  this.helpersService.saveProfileInsuranceRoles(permissions);
                  this.router.navigateByUrl('/insurance/claims');
                },
                (error) => {
                  this.loggingIn = false;
                  this.error = true;
                  this.errorMessage =
                    'There was an error getting the user profile details. Please try again later.';
                },
              );
            },
            (error) => {
              this.loggingIn = false;
              this.error = true;
              this.errorMessage =
                'There was an error getting the user profile details. Please try again later.';
            },
          );
        },
        (error) => {
          this.loggingIn = false;
          this.error = true;
          this.errorMessage =
            error && error.error_description
              ? error.error_description
              : 'The user name or password is incorrect.';
        },
      );
  }
}

